// extracted by mini-css-extract-plugin
module.exports = {"clipboard":"Clipboard_clipboard__2J8T3","icon":"Clipboard_icon__twvJn"};